import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany } from '@apexdesigner/schema-tools';

export const processMessage = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .requiredFinal()
      .describe('Message name senders use'),

    displayName: z
      .string()
      .nullable()
      .optional()
      .meta({ format: 'capitalCase' })
      .describe('Human-readable label'),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Description'),

    properties: hasMany('ProcessMessageProperty', 'messageId'),
  })
  .describe(
    'A message a process can send or wait for via receive tasks, message boundary events, message start events and send tasks.',
  )
  .as('ProcessMessage');

export { processMessage as processMessageSchema };
